import React, { useEffect, useRef, useState } from "react";

import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import { landingIcon1, logImg2 } from "../../../Entryfile/imagepath";
import { HrApi } from "../../../initialpage/hooks/HrApi";
import { useNavigate } from "react-router-dom";
const AllEmployeeReports = () => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const navigate = useNavigate();
  const [allEmployeeData, setAllEmployeeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  let counter = 1;
  useEffect(() => {
    const getUsers = () => {
      setIsLoading(true);
      fetch(`${HrApi}/hr/emp/getAllEmp`)
        .then((res) => {
          // You have to send it, as I have done below
          if (res.status >= 400) {
            throw new Error("Server responds with error!");
          }
          return res.json();
        })
        .then(
          (users) => {
            setAllEmployeeData(users.data);
            console.log(users.data);
          },

          (err) => {
            const mute = err;
            setHasError(true);
            setIsLoading(true);
          }
        );
    };

    getUsers();
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        {/* <div className="row bg-project p-3 mb-3">
          <div className="container col-sm-3 text-start mb-3">
            <label
              htmlFor="inputGroupSelect13"
              className="form-label text-light fs-6 fw-bold"
            >
              Department
            </label>
            <Select
              options={categoryOptions1}
              onChange={handleDepartmentSelectCategory}
            />
          </div>
          <div className="container col-sm-3 text-start mb-3">
            <label
              htmlFor="inputGroupSelect13"
              className="form-label text-light fs-6 fw-bold"
            >
              Year wise PRL
            </label>
            <input
              type="year"
              onChange={(e) => {
                setBloodGroup("");
                setGetYear(e.target.value);
              }}
              className="form-control"
              id="exampleFormControlInput14"
            />
          </div>
          <div className="container col-sm-3 text-start mb-3">
            <label
              htmlFor="inputGroupSelect13"
              className="form-label text-light fs-6 fw-bold"
            >
              Blood Group
            </label>
            <select
              onChange={(e) => {
                setGetYear("");
                setBloodGroup(e.target.value);
              }}
              className="form-select form-select-lg mb-3"
              aria-label=".form-select-lg example"
            >
              <option value="">Select Blood Group</option>
              <option value="A+">A+</option>
              <option value="B+">B+</option>
              <option value="O+">O+</option>
              <option value="A-">A-</option>
              <option value="B-">B-</option>
              <option value="O-">O-</option>
              <option value="AB+">AB+</option>
              <option value="AB-">AB-</option>
            </select>
          </div>

          <div className="container col-sm-2 text-start mb-3 mt-4">
            <button
              className="btn btn-primary px-3 py-2"
              onClick={handleAllReport}
            >
              All Employees
            </button>
          </div>
        </div> */}
        <div className="text-end mt-4 me-4">
          <button
            className="btn  text-end me-3"
            style={{ backgroundColor: "#D80017", color: "white" }}
            onClick={handlePrint}
          >
            <i className="la la-file-pdf-o"></i> PDF!
          </button>
          <button
            onClick={() => navigate(-1)}
            style={{
              marginTop: "10px",
              padding: "7px 20px",
              backgroundColor: "black",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            ← Back
          </button>
        </div>

        <div
          ref={componentRef}
          style={{ width: "100%", minHeight: "100vh" }}
          className="my-4"
        >
          <div className=" mt-1 p-4 mx-auto container">
            <div className="row text-center">
              <div className="col-3">
                <img
                  className="img-fluid"
                  width="80"
                  src={landingIcon1}
                  alt=""
                />
              </div>
              <div className="col-6">
                <h4>INFOTECH IT SOLUTIONS</h4>

              </div>
            </div>
            <h3 className="mb-3 text-center mt-4">All Employees</h3>
            <hr className="border-bottom border-2 border-dark mb-4" />

            <table className="table w-full border border-gray-300 bg-white my-5 text-start">
              <thead>
                <tr className="bg-gray-100">
                  <th
                    className=" border-gray-300 px-4 py-2"
                    style={{
                      borderRight: "1px solid #dee2e6",
                      backgroundColor: "#D80017",
                      color: "black",
                    }}
                  >
                    S/N
                  </th>
                  <th
                    className=" border-gray-300 px-4 py-2"
                    style={{
                      borderRight: "1px solid #dee2e6",
                      backgroundColor: "#D80017",
                      color: "black",
                    }}
                  >
                    Employee ID
                  </th>
                  <th
                    className=" border-gray-300 px-4 py-2"
                    style={{
                      borderRight: "1px solid #dee2e6",
                      backgroundColor: "#D80017",
                      color: "black",
                    }}
                  >
                    Name
                  </th>
                  <th
                    className=" border-gray-300 px-4 py-2"
                    style={{
                      borderRight: "1px solid #dee2e6",
                      backgroundColor: "#D80017",
                      color: "black",
                    }}
                  >
                    Designation
                  </th>
                  <th
                    className=" border-gray-300 px-4 py-2"
                    style={{
                      borderRight: "1px solid #dee2e6",
                      backgroundColor: "#D80017",
                      color: "black",
                    }}
                  >
                    Departement
                  </th>
                  <th
                    className=" border-gray-300 px-4 py-2"
                    style={{
                      borderRight: "1px solid #dee2e6",
                      backgroundColor: "#D80017",
                      color: "black",
                    }}
                  >
                    Phone
                  </th>
                </tr>
              </thead>
              <tbody>
                {allEmployeeData.map((reports, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className=" px-4 py-2">{index + 1}</td>
                    <td className="border border-gray-300 px-4 py-2">
                      {reports.EMPLOYE_REGISTRATION_NUMBER}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {reports.NAME_ENGLISH}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {reports.DESIGNATION}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {reports.DEPARTEMENT}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {reports.MOBILE_PHONE}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllEmployeeReports;
